app.controller("CreateNotificationController", ["$scope", "$q", "StaticData", "$stateParams", "$filter", "$uibModal", "ConfirmModal", "AuthService", "ProgramService", "Students", "Lecturer", "Users", "$state", "NotificationService", "toastr", "usSpinnerService",
    function ($scope, $q, StaticData, $stateParams, $filter, $uibModal, ConfirmModal, AuthService, ProgramService, Students, Lecturer, Users, $state, NotificationService, toastr, usSpinnerService) {
        $scope.totalItems = 0;
        $scope.title = null;
        $scope.foo = null;
        $scope.reply = false;
        $scope.receiver = "student";
        $scope.priority = 3;
        $scope.program = null;
        $scope.level = null;
        $scope.state = null;
        $scope.faculty = null;
        $scope.gender = null;
        $scope.activeState = null;
        $scope.semester = 'სემესტრი';
        $scope.semesters = ['სემესტრი'].concat(_.range(1, 15));
        $scope.panelTitle = 'შეტყობინების შექნა';
        $scope.buttonText = 'გაგზავნა';
        $scope.operationType = 'send';
        $scope.notifyOnMail = false;
        $scope.users = [];
        $scope.selectedFaculties = [];
        $scope.selectedPrograms = [];
        $scope.selectedStates = [];
        $scope.selectedSemesters = [];

        function fillFilterFields() {
            if ($stateParams.faculty) {
                var faculty = $stateParams.faculty;
                faculty = typeof faculty === 'string' ? [faculty] : faculty;
                $scope.selectedFaculties = $scope.faculties.filter(function (fac) {
                    return faculty.indexOf(fac._id) > -1
                });
            }
            if ($stateParams.program) {
                ProgramService.fetchList($stateParams.program).then(function (programs) {
                    $scope.programs = programs;
                });
            }
            if ($stateParams.state) {
                var state = $stateParams.state;
                state = typeof state === 'string' ? [state] : state;
                $scope.selectedStates = $scope.states.filter(function (st) {
                    return state.indexOf(st._id) > -1
                });
            }

            if ($stateParams.semester) {
                var semester = $stateParams.semester;
                semester = typeof semester === 'string' ? [semester] : semester;
                $scope.selectedSemesters = semester;
            }
        }

        $scope.getUsers = function (query) {
            if (query.length < 2) {
                return [];
            }
            return Users.list({query: query}).then(function (data) {
                return data.docs.filter(function (usr) {
                    var el_index = _.findIndex($scope.users, function (user) {
                        return user._id === usr._id;
                    });
                    return el_index === -1;
                })
            });
        };

        $scope.$watch('user', function (val) {
            if (val && val._id) {
                $scope.users.push(val);
                $scope.user = null;
                $scope.totalItems = $scope.users.length;
            }
        }, true);

        $scope.delete_user = function (id) {
            var el_index = _.findIndex($scope.users, function (user) {
                return id === user._id;
            });

            $scope.users.splice(el_index, 1);
            $scope.totalItems = $scope.users.length;
        };

        $scope.addFacultyToFilter = function () {
            if ($scope.selectedFaculties.map(function (fac) {
                return fac._id
            }).indexOf($scope.faculty) > -1) return;
            $scope.selectedFaculties.push($scope.faculties.find(function (f) {
                return f._id === $scope.faculty
            }));
            $scope.faculty = $scope.faculties[0]._id;
            $scope.getStudents();
        };

        $scope.removeFaculty = function (fac) {
            $scope.selectedFaculties = $scope.selectedFaculties.filter(function (f) {
                return f !== fac
            });
            $scope.getStudents();
        }

        $scope.addProgramToFilter = function () {
            if ($scope.selectedPrograms.indexOf($scope.program) > -1) return;
            $scope.selectedPrograms.push($scope.program);
            $scope.program = null;
            $scope.getStudents();
        };

        $scope.removeProgram = function (pr) {
            $scope.selectedPrograms = $scope.selectedPrograms.filter(function (p) {
                return p._id !== pr._id
            });
            $scope.getStudents();
        };

        $scope.addStateToFilter = function () {
            if ($scope.selectedStates.map(function (st) {
                return st._id
            }).indexOf($scope.state) > -1) return;
            $scope.selectedStates.push($scope.states.find(function (s) {
                return s._id === $scope.state
            }));
            $scope.state = $scope.states[0]._id;

            $scope.getStudents();
        };

        $scope.removeState = function (st) {
            $scope.selectedStates = $scope.selectedStates.filter(function (s) {
                return s !== st
            });
            $scope.getStudents();
        }

        $scope.addSemesterToFilter = function () {
            if ($scope.selectedSemesters.indexOf($scope.semester) > -1) return;
            $scope.selectedSemesters.push($scope.semester);
            $scope.semester = $scope.semesters[0];
            $scope.getStudents();
        };

        $scope.removeSemester = function (sem) {
            $scope.selectedSemesters = $scope.selectedSemesters.filter(function (s) {
                return s !== sem
            });
            $scope.getStudents();
        }

        $scope.personalNos = function () {
            $uibModal.open({
                controller: "UserPersonalNosController",
                templateUrl: _pb + 'admin/notifications/user-personalnos.html',
                size: "md",
                backdrop: 'static',
            }).result
                .then(function (result) {
                    $scope.users = $scope.users.concat(result);
                    $scope.totalItems = $scope.users.length;
                }, function () {

                });
        };

        if ($stateParams.operationType) $scope.operationType = $stateParams.operationType;
        if ($scope.operationType === 'edit') {
            $scope.panelTitle = 'შეტყობინების რედაქტირება';
            $scope.buttonText = 'რედაქტირება';
        } else if ($scope.operationType === 'resend') {
            $scope.panelTitle = 'შეტყობინების გადაგზავნა';
            $scope.buttonText = 'გადაგზავნა';
        }

        if ($stateParams.notificationId) {
            // TODO recover filter
            NotificationService.getById({
                notificationId: $stateParams.notificationId
            }).then(function (not) {
                $scope.title = not.title;
                $scope.priority = not.priority;
                $scope.foo = not.text;
                $scope.reply = not.reply;
                $scope.activeState = not.onlyActiveLectures;
                $scope.receiver = not.receivers.type;
                $scope.notifyOnMail = not.notifyOnMail;
                if (not.receivers.type === "student") {
                    $scope.faculty = not.receivers.faculty;
                    $scope.level = not.receivers.level;
                    $scope.program = not.receivers.program;
                    $scope.state = not.receivers.state;
                    $scope.semester = not.receivers.semester;
                    $scope.gender = not.receivers.gender;
                    $scope.getStudents();
                }
            })
        }

        $q.all([
            StaticData.getItemsByKey("priorities"),
            StaticData.getItemsByKey("faculties"),
            StaticData.getItemsByKey("levels"),
            StaticData.getItemsByKey("states"),
            StaticData.getItemsByKey("gender")
        ]).then(function (results) {
            var priorities = results[0];
            var faculties = results[1];
            var levels = results[2];
            var states = results[3];
            var genders = results[4];

            $scope.priorities = priorities;
            $scope.faculties = [{name: "ფაკულტეტი"}].concat(faculties);
            $scope.levels = [{name: "საფეხური"}].concat(levels);
            $scope.states = [{name: "სტატუსი"}].concat(states);
            $scope.genders = [{name: "სქესი"}].concat(genders);
            fillFilterFields();
        });

        $scope.getPrograms = function (name) {
            if (name.length < 1) {
                return [];
            }
            var params = {};
            params.query = name;
            return ProgramService.list(params).then(function (data) {
                return data.docs;
            });
        };

        $scope.changeReply = function (newType) {
            $scope.reply = newType;
        };

        $scope.changeReceiver = function (newType) {
            if (newType === 'lecturer') {
                StaticData.getItemsByKey("lecturer_states").then(function (activeStates) {
                    $scope.activeStates = [{name: "მდგომარეობა"}].concat(activeStates);
                });
                $scope.activeStates = null;
                $scope.getLecturers();
            }
            if (newType === 'student') {
                $scope.getStudents();
            } else {
                $scope.state = null;
                $scope.faculty = null;
                $scope.program = null;
                $scope.level = null;
                $scope.gender = null;
                $scope.semester = 'სემესტრი';
            }
            $scope.totalItems = 0;
            $scope.receiver = newType;
        };

        $scope.getStudents = function () {
            usSpinnerService.spin("root");
            Students.list({
                query: $scope.query,
                faculty: $scope.selectedFaculties.length ? $scope.selectedFaculties.map(function (f) {
                    return f._id;
                }) : undefined,
                level: $scope.level,
                state: $scope.selectedStates.length ? $scope.selectedStates.map(function (s) {
                    return s._id;
                }) : undefined,
                semester: $scope.selectedSemesters.length ? $scope.selectedSemesters.map(function (s) {
                    return s;
                }) : undefined,
                program: $scope.selectedPrograms.length ? $scope.selectedPrograms.map(function (s) {
                    return s._id;
                }) : undefined,
                gender: $scope.gender
            }).then(function (data) {
                if ($scope.receiver === 'student') {
                    $scope.totalItems = data.total;
                }
                usSpinnerService.stop("root");
            });
        };

        $scope.getLecturers = function () {
            Lecturer.list({
                activeState: $scope.activeState
            }).then(function (data) {
                $scope.totalItems = data.total
            });
        };

        $scope.show = function () {
            var notification = {
                text: $scope.foo,
                title: $scope.title,
                priority: $scope.priority,
                reply: $scope.reply,
                createDateString: $filter('date')(new Date(), 'HH:mm dd-MM-yyyy')
            };
            if ($scope.reply) {
                AuthService.getUserData().then(function (user) {
                    notification.author = {
                        firstName: user.firstName,
                        lastName: user.lastName
                    }
                });
            } else {
                notification.showAs = 'უნივერსიტეტის ადმინისტრაცია';
            }

            $uibModal.open({
                controller: "NotificationsWindowController",
                templateUrl: _pb + 'notifications/notification-window.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {notification: notification};
                    }
                }
            }).result
                .then(function (result) {

                }, function () {

                });
        };

        $scope.send = function () {
            var notification = {
                _id: $stateParams.notificationId || undefined,
                update: $scope.operationType === 'edit',
                text: $scope.foo,
                title: $scope.title,
                priority: $scope.priority,
                reply: $scope.reply,
                notifyOnMail: $scope.notifyOnMail,
                receiversList: [],
                receivers: {
                    type: $scope.receiver,
                    level: $scope.level,
                    gender: $scope.gender,
                    state: $scope.selectedStates.length ? $scope.selectedStates.map(function (s) {
                        return s._id;
                    }) : undefined,
                    faculty: $scope.selectedFaculties.length ? $scope.selectedFaculties.map(function (f) {
                        return f._id;
                    }) : undefined,
                    program: $scope.selectedPrograms.length ? $scope.selectedPrograms.map(function (s) {
                        return s._id;
                    }) : undefined,
                    semester: $scope.selectedSemesters.length ? $scope.selectedSemesters.map(function (s) {
                        return s;
                    }) : undefined
                }
            };

            if ($scope.receiver === 'users') {
                notification.receiversList = $scope.users;
            }

            if ($scope.receiver === 'lecturer') {
                notification.onlyActiveLectures = $scope.activeState;
            }

            if (!$scope.title) toastr.error('', 'გთხოვთ ჩაწეროთ სათაური');
            else if (!$scope.foo) toastr.error('', 'გთხოვთ ჩაწეროთ ტექსტი');
            else {
                if ($scope.operationType === 'send') {

                    NotificationService.send(notification).then(function () {
                        toastr.success('', 'შეტყობინება გაგზავნილია');
                        $state.go('admin.notification.send')
                    }).catch(function () {
                        toastr.error('', 'შეტყობინების გაგზავნისას დაფიქსირდა შეცდომა');
                    })
                }
                else if ($scope.operationType === 'resend') {
                    NotificationService.send(notification).then(function () {
                        toastr.success('', 'შეტყობინება გადაგზავნილია');
                        $state.go('admin.notification.send')
                    }).catch(function () {
                        toastr.error('', 'შეტყობინების გადაგზავნისას დაფიქსირდა შეცდომა');
                    })
                }
                else if ($scope.operationType === 'edit') {
                    ConfirmModal.show({
                        title: "ყურადღება",
                        message: "შეტყობინება პირვანდელი სახით წაიშლება და შეინახება მხოლოდ რედაქტირებული"
                    }).result.then(function () {
                        NotificationService.send(notification).then(function () {
                            toastr.success('', 'შეტყობინება რედაქტირებულია');
                            $state.go('admin.notification.send')
                        }).catch(function () {
                            toastr.error('', 'შეტყობინების რედაქტირებისას დაფიქსირდა შეცდომა');
                        })
                    });
                }
            }
        };
    }
]);
